import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ErrorHelper {

    handleError(httpError: HttpErrorResponse) {
        console.log(httpError);
        return Observable.throw(httpError.statusText);

    }

    mapToError(tr: any) {
        return tr;
    }
}
